export default __webpack_public_path__ + "static/media/hht2_ep13_timeline_q04_a.e08ab3a8.png";